var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12464_18601)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1205 29.1595C35.9353 26.5647 37 23.4067 37 20C37 11.1634 29.8366 4 21 4C12.1634 4 5 11.1634 5 20C5 23.4067 6.06469 26.5647 7.87947 29.1595C7.90139 29.2943 7.95236 29.4285 8.03647 29.5547L20.1679 47.7519C20.5638 48.3457 21.4362 48.3457 21.832 47.7519L33.9635 29.5547C34.0476 29.4285 34.0986 29.2943 34.1205 29.1595Z",
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12464_18601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12464_18601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.875 27.5L13.5 23.125V16.875L17.875 12.5H24.125L28.5 16.875V23.125L24.125 27.5H17.875ZM18.625 23.5417L21 21.1667L23.375 23.5417L24.5417 22.375L22.1667 20L24.5417 17.625L23.375 16.4583L21 18.8333L18.625 16.4583L17.4583 17.625L19.8333 20L17.4583 22.375L18.625 23.5417ZM18.5833 25.8333H23.4167L26.8333 22.4167V17.5833L23.4167 14.1667H18.5833L15.1667 17.5833V22.4167L18.5833 25.8333Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12464_18601",
    x: 0,
    y: 0,
    width: 42,
    height: 54.1973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12464_18601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12464_18601",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsafety);
export default __webpack_public_path__ + "static/media/unsafety.8379d98804af3c138b7201d2c298f582.svg";
export { ForwardRef as ReactComponent };